exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modify-package-modal .card{font-size:.75rem}.modify-package-modal .card .card-header{font-size:.95rem;padding:.1rem 1rem}.modify-package-modal .card .card-header .btn{padding:1px 8px}.modify-package-modal .card .form-group{margin-bottom:.5rem}.modify-package-modal .card .input-group-text,.modify-package-modal .card button,.modify-package-modal .card input,.modify-package-modal .card label,.modify-package-modal .card select{font-size:.75rem}.modify-package-modal .card input::-webkit-inner-spin-button,.modify-package-modal .card input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.modify-package-modal .card .dropdown .dropdown-toggle{padding:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a0bf0a2c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Modals/PrepaidReturnModal.vue
// module id = SryV
// module chunks = 1